<template>
  <a :href="`tel:${tel}`">
    <div class="phone">
      <phone-image class="phone__icon" />
      {{ tel }}
    </div>
  </a>
</template>

<script>
import PhoneImage from "@/assets/images/phone.svg";

export default {
  name: "BasePhone",
  components: {
    PhoneImage
  },
  props: {
    tel: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.phone {
  display: flex;
  align-items: center;
  color: $color-blue-300;

  &__icon {
    margin-right: 12px;
    fill: $color-blue-300;
  }
}

@media screen and (min-width: $media-m) {
  .phone {
    color: initial;

    &__icon {
      fill: initial;
    }
  }
}
</style>
